import { useCallback, useEffect, useMemo, useRef, useState } from "react";

import { useTranslation } from "react-i18next";

import { logDebug } from "../../utils/logger.js";
import { isEmpty } from "../../utils/validators.js";

function Logo() {
  const { t } = useTranslation();

  const goHomeHandler = useCallback((evt) => {
    logDebug("Logo", "goHomeHandler", { evt: evt });
    window.location.replace(process.env.REACT_APP_PUBLIC_URL);
  }, []);

  const [srcIdx, setSrcIdx] = useState(0);
  const src = useMemo(
    () => [
      // Logo Animation
      "../../../assets/images/logo1.svg",
      "../../../assets/images/logo2.svg",
      "../../../assets/images/logo3.svg",
      // Success
      "../../../assets/images/logo4.svg",
      // Special Occasions
      // ...
    ],
    []
  );

  const intervalRef = useRef(null);

  const initialHandler = useCallback(() => {
    if (!isEmpty(intervalRef) && !isEmpty(intervalRef.current)) {
      clearInterval(intervalRef.current);
    }
    setSrcIdx(0);
    logDebug("logo", "initialHandler", { step: 0, logo: src[0] });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    initialHandler();
  }, [initialHandler]);

  return (
    <div className="logo-container" onClick={(evt) => goHomeHandler(evt)}>
      <img
        className="logo"
        src={src[srcIdx]}
        loading="eager"
        alt={t("logo.alt")}
        title={t("logo.title")}
        height="auto"
        width="auto"
      ></img>
      <img
        className="wordmark"
        src="../../../assets/images/ydray-wordmark-black.svg"
        loading="eager"
        alt={t("wordmark.alt")}
        title={t("wordmark.title")}
        height="auto"
        width="auto"
      ></img>
    </div>
  );
}

export default Logo;
